import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import type { QuizWho } from "./types";

export interface QuizStepNameProps {
  who: QuizWho | "";
  value: string;
  onChange: (name: string) => void;
  error: string | null;
  onNext: () => void;
}

const placeholders: Record<string, string> = {
  your: "Your name",
  child: "Their name",
  their: "Their name",
};
const titles: Record<string, string> = {
  your: "What's your preferred name?",
  child: "What's your child's name?",
  their: "What's their preferred name?",
};

export const QuizStepName: React.FC<QuizStepNameProps> = ({
  who,
  value,
  onChange,
  error,
  onNext,
}) => {
  const title = who ? (titles[who] ?? titles.their) : titles.their;
  const placeholder = who
    ? (placeholders[who] ?? placeholders.their)
    : placeholders.their;

  return (
    <motion.li
      className="step"
      data-step="name"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="quiz-inner">
        <div className="quiz-title" data-question-type="title">
          <h2>{title}</h2>
        </div>
        <div data-question-type="input-text">
          <input
            type="text"
            id="quiz-step-name"
            name="quiz-step-name"
            className="quiz-input"
            autoFocus
            autoCapitalize="words"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onNext();
                return;
              }
            }}
            pattern="[A-Za-z]+"
            autoComplete="given-name"
          />
        </div>
        <AnimatePresence mode="wait">
          {error && (
            <motion.div
              key={error}
              className="quiz-error"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.li>
  );
};
